'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactBootstrap = require('react-bootstrap');

var _InputBlock = require('./InputBlock');

var _InputBlock2 = _interopRequireDefault(_InputBlock);

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// InputBlock 就等於進到 input editor，因此在此切分 props
function EditorRow(props) {
  var blocks = props.blocks,
      config = props.ui.config,
      spliter = props.spliter;

  var getChildProps = spliter(props);

  return _react2.default.createElement(
    _reactBootstrap.Row,
    null,
    blocks.map(function (block, index) {
      return _react2.default.createElement(
        _reactBootstrap.Col,
        { key: index, md: 12 / blocks.length, sm: 12 / blocks.length },
        block.key && _react2.default.createElement(_InputBlock2.default, _extends({ config: config, block: block }, getChildProps(block.key)))
      );
    })
  );
}
EditorRow.propTypes = {
  blocks: _propTypes.array.isRequired,
  spliter: _propTypes.func.isRequired,
  ui: _propTypes.object.isRequired
};

function EditorGroup(props) {
  var name = props.name,
      rows = props.rows,
      passing = _objectWithoutProperties(props, ['name', 'rows']);

  return _react2.default.createElement(
    _reactBootstrap.Grid,
    { className: _style2.default.group },
    _react2.default.createElement(
      _reactBootstrap.Row,
      null,
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 12, sm: 12 },
        _react2.default.createElement(
          'div',
          { className: _style2.default.groupTitle },
          name
        )
      )
    ),
    rows.map(function (row, index) {
      return _react2.default.createElement(EditorRow, _extends({ key: index }, passing, { blocks: row }));
    })
  );
}
EditorGroup.propTypes = {
  name: _propTypes.string.isRequired,
  rows: _propTypes.array.isRequired
};

function EditorButtons(_ref) {
  var saveEditing = _ref.saveEditing,
      routeToNewDoc = _ref.routeToNewDoc,
      routeToCopyDoc = _ref.routeToCopyDoc,
      cancelEditing = _ref.cancelEditing;

  return _react2.default.createElement(
    _reactBootstrap.Grid,
    null,
    _react2.default.createElement(
      _reactBootstrap.Row,
      { className: _style2.default.btnLine },
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 2, sm: 2 },
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn-primary form-control',
            onClick: saveEditing
          },
          '\u5132\u5B58'
        )
      ),
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 2, sm: 2 },
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn-primary form-control',
            onClick: routeToNewDoc
          },
          '\u5132\u5B58\u5F8C\u65B0\u589E'
        )
      ),
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 2, sm: 2 },
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn-primary form-control',
            onClick: routeToCopyDoc
          },
          '\u8907\u88FD\u4F86\u65B0\u589E'
        )
      ),
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 2, sm: 2 },
        _react2.default.createElement(
          'button',
          {
            className: _style2.default.btnLink + ' ' + _style2.default.btnCancel,
            onClick: cancelEditing
          },
          '\u53D6\u6D88'
        )
      )
    )
  );
}
EditorButtons.propTypes = {
  saveEditing: _propTypes.func.isRequired,
  routeToNewDoc: _propTypes.func.isRequired,
  routeToCopyDoc: _propTypes.func.isRequired,
  cancelEditing: _propTypes.func.isRequired
};

// if create function on every render
// callback will be called every render
// const focusWhenMounted = el => {
//   if (el) el.focus()
// }

// 分成 consume 跟 inject，
var DocEditor = function DocEditor(props) {
  var _props$ui = props.ui,
      title = _props$ui.title,
      groups = _props$ui.groups,
      gotoDocList = props.gotoDocList;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h3',
      { className: _style2.default.pageTitle, style: { cursor: 'pointer' }, onClick: gotoDocList },
      title
    ),
    _react2.default.createElement(
      'div',
      { className: _style2.default.form },
      _react2.default.createElement(EditorButtons, props),
      groups.map(function (group, index) {
        return _react2.default.createElement(EditorGroup, _extends({
          key: index
        }, group, props));
      }),
      _react2.default.createElement(EditorButtons, props)
    )
  );
};
DocEditor.propTypes = {
  ui: (0, _propTypes.shape)({
    title: _propTypes.string,
    groups: _propTypes.array.isRequired
  }),
  gotoDocList: _propTypes.func.isRequired
};

exports.default = DocEditor;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/DocEditor.js
// module id = 1721
// module chunks = 0